import React, { useState } from 'react';
import { Card } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { ResponseError } from '../../../common/pokCore/autogenerated/pokApiClient';
import { Waiting } from '../../../common/components/Waiting/Waiting';
import { useTranslation } from '../../../common/hooks/useTranslation';
import Button from '../../../common/components/Button/Button';

export const ReportClientsContactsView: React.FC = () => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const [waiting, setWaiting] = useState<boolean>(false);
  const { t, tk } = useTranslation('reportLng');

  const onDownload = async () => {
    setWaiting(true);
    const currentDate = new Date().toISOString().split('T')[0];
    try {
      await pok.reports.reportClientsContacts(
        `${t(tk.administration.clientsContactsFile)}_${currentDate}.xlsx`,
      );
      setWaiting(false);
    } catch (error) {
      notifications.caughtError(error as ResponseError);
      setWaiting(false);
    }
  };

  return (
    <Card className="mb-2">
      <Card.Header>{t(tk.administration.clientsContacts)}</Card.Header>
      <Card.Body>
        {waiting ? (
          <Waiting />
        ) : (
          <div className="d-flex justify-content-end mt-3">
            <Button variant="outline-primary" onClick={onDownload}>
              {t(tk.button.export)}
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};
